import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { AfipSaveDraftsService } from 'src/app/services/electronic-billing/afip-guardar-comprobantes.service';

@Component({
  selector: 'app-electronic-billing-save-comprobantes',
  templateUrl: './electronic-billing-save-comprobantes.component.html',
  styleUrls: ['./electronic-billing-save-comprobantes.component.scss'],
})
export class ElectronicBillingSaveComprobantesComponent implements OnInit {
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  value: any;

  status = {
    right: 0,
    wrong: 0,
  };

  loading = true;

  constructor(private readonly saveDraftsService: AfipSaveDraftsService) {}

  ngOnInit(): void {
    this.loading = true;
    if (this.value) {
      this.saveDrafts(this.value);
    }
  }

  saveDrafts(dto: any) {
    this.saveDraftsService.post(dto, '').then((response: any) => {
      if (response?.body?.data) {
        const result: any[] = [];
        response.body.data.comprobantes.forEach((e: any) => {
          if (e.valido) {
            this.status.right++;
            result.push(e);
          }
        });
        this.status.wrong =
          response.body.data.comprobantes.length - this.status.right;
        response.body.data.comprobantes = result;

        const EMIT = result.length > 0 ? response.body.data : 'disabled';
        this.change.emit(EMIT);
        this.loading = false;
      }
    });
  }
}
